export class AbstractEntity {
    id: number = -1;
}
